import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import formRules from './formRules';
import ErrorComponent from '../../components/Error';
import {
  injectFormState,
  onChangeFieldText,
  onBlurFieldText,
  formValidate,
} from '../../utils/form';
// translate
import messages from './messages';

class Signup extends Component {
  constructor(props) {
    super(props);

    const attributes = {
      login: '',
      email: '',
      password: '',
    };

    this.state = Object.assign(
      {
        attributes,
      },
      injectFormState(formRules, attributes),
    );

    this.formValidate = formValidate.bind(this);
    this.onChangeFieldText = onChangeFieldText.bind(this);
    this.onBlurFieldText = onBlurFieldText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    this.formValidate(this.state.attributes).then((data) => {
      if (data.status) {
        this.props.onSignupClick(this.state.attributes);
      }
    });
  }

  renderForm() {
    const { intl, isFetching } = this.props;
    const { validation } = this.state.formSchema;

    return (
      <form className="popup-form" method="post">
        <label className="label" htmlFor="login">
          {validation.login.message &&
            <span className="popup-form-error">
              {intl.formatMessage(validation.login.message)}
            </span>}
          <input
            type="text"
            name="login"
            placeholder={intl.formatMessage(messages.placeholderLogin)}
            onChange={this.onChangeFieldText}
            onBlur={this.onBlurFieldText}
          />
        </label>

        <label className="label" htmlFor="email">
          {validation.email.message &&
            <span className="popup-form-error">
              {intl.formatMessage(validation.email.message)}
            </span>}
          <input
            type="text"
            name="email"
            data-validation-onchange={false}
            placeholder={intl.formatMessage(messages.placeholderEmail)}
            onChange={this.onChangeFieldText}
            onBlur={this.onBlurFieldText}
          />
        </label>

        <label className="label" htmlFor="password">
          {validation.password.message &&
            <span className="popup-form-error">
              {intl.formatMessage(validation.password.message)}
            </span>}
          <input
            type="password"
            name="password"
            placeholder={intl.formatMessage(messages.placeholderPassword)}
            onChange={this.onChangeFieldText}
            onBlur={this.onBlurFieldText}
          />
        </label>

        <button
          className="trans"
          type="button"
          disabled={isFetching}
          onClick={this.onSubmit}
        >
          {intl.formatMessage(messages.signupButton)}
        </button>
      </form>
    );
  }

  render() {
    const { intl, signupErrorMessage, signupSuccess, isFetching } = this.props;

    return (
      <div>
        {!signupSuccess && this.renderForm()}
        {signupSuccess &&
          <div className="popup-form-success">
            <FormattedHTMLMessage {...messages.successText} />
          </div>}
        {signupErrorMessage &&
          !isFetching &&
          <ErrorComponent>{signupErrorMessage}</ErrorComponent>}
        <p className="popup-body-header">
          {intl.formatMessage(messages.loginText)}
        </p>
        <Link className="button trans go-register" to="#login">
          {intl.formatMessage(messages.loginButton)}
        </Link>
      </div>
    );
  }
}

Signup.propTypes = {
  intl: intlShape.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  signupErrorMessage: PropTypes.any,
  signupSuccess: PropTypes.bool.isRequired,
};

Signup.defaultProps = {
  signupErrorMessage: false,
};

export default injectIntl(Signup);



// WEBPACK FOOTER //
// ./src/components/Signup/index.js